export enum REGION_ID {
  MSK = '019e3e0d-3589-7143-837f-aed104fd9584',
  SPB = '019e3e0d-35e7-73a1-8b1f-d6972df479e2',
  EKB = '019e3e0d-2224-7273-86ed-a1af33bef478',
  KZN = '019e3e0c-d71a-7245-9ca0-7e9ca353cced',
  KRD = '019e3e0c-dd83-7072-a3ef-9ca150818aba',
  NNVGRD = '019e3e0d-0afe-703b-a2cc-69f6be48d8f0',
  NSK = '019e3e0d-0ffa-7237-b5a8-efa5ffce6db3',
  OMSK = '019e3e0d-10f6-7126-a318-46804e2b05a2',
  RND = '019e3e0d-1d93-72e1-8ea7-396be22ba12e',
  SMR = '019e3e0d-204e-7003-a8e9-42e2ed0bfe2f',
  CHLB = '019e3e0d-31a2-70a2-a742-9f8f2fd9801e',
}

export const useCommonStore = defineStore('common', () => {
  const directoryStore = useDirectoryStore()
  const currentRegion = computed(() => {
    if (!directoryStore.regions) return undefined
    return (
      directoryStore.regions.find((region) => region.id === REGION_ID.MSK) ||
      directoryStore.regions[0]
    )
  })
  const currentRegionId = computed(
    () => currentRegion.value?.id || REGION_ID.MSK,
  )

  return {
    currentRegion,
    currentRegionId,
  }
})
